import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/common/LoadingSpinner';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    // Save the intended location to redirect back after login
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If user doesn't have the required role
  if (user && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on user's actual role
    let redirectPath = '/';
    
    switch(user.role) {
      case 'buyer':
        redirectPath = '/buyer/dashboard';
        break;
      case 'seller':
        redirectPath = '/seller/dashboard';
        break;
      case 'admin':
        redirectPath = '/admin/dashboard';
        break;
      default:
        redirectPath = '/';
    }
    
    return <Navigate to={redirectPath} replace />;
  }

  // User is authenticated and has the required role
  return children;
};

export default ProtectedRoute;